import React from 'react';
import { List, Datagrid, TextField, Filter, TextInput, EditButton } from 'react-admin';

import BoolNumField from '../controls/BoolNumField';
import ErrorBoundary from '../ErrorBoundary';

const VendorFilters = props => (
    <Filter {...props}>
        <TextInput source="name" label="Vendor Name" alwaysOn />
        <TextInput source="code" label="Code" />
    </Filter>
);

const VendorList = props => (
    <ErrorBoundary>
        <List
            {...props}
            title="Supply Vendors"
            filters={<VendorFilters />}
            perPage={25}
            sort={{ field: 'name', order: 'ASC' }}
            bulkActionButtons={false}
            exporter={false}
        >
            <Datagrid>
                <TextField source="name" label="Vendor Name" />
                <TextField source="code" label="Code" />
                <TextField source="contact" label="Contact" />
                <TextField source="phone" label="Phone" />
                <TextField source="email" label="Email" />
                <BoolNumField source="status" label="Is Active?" />
                <EditButton />
            </Datagrid>
        </List>
    </ErrorBoundary>
);

export default VendorList;
